// extracted by mini-css-extract-plugin
module.exports = {"modal_td":"ResultModal_modal_td__23Ptk"};